<template>
  <div class="home-box">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2 orange--text">District Dues | Month: {{ month }}</h3>
        <v-spacer></v-spacer>
        <go-back-btn></go-back-btn>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-form class="pa-5" v-if="districtDue && !loading">
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">
              District Dues for the full year paid to Cabinet Treasurer
            </div>
            <div class="caption">
              {{ districtDue.paid == 1 ? "Yes" : "No" }}
            </div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">
              Amount
            </div>
            <div class="caption">
              {{ districtDue.amount }}
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Bank</div>
            <div class="caption">
              {{ districtDue.bank }}
            </div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Date</div>
            <div class="caption">{{ districtDue.date }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <div class="subtitle-1">Cheque No / Cash Deposit Slip</div>
            <div class="caption">
              {{ districtDue.payment_comment }}
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row v-if="districtDue.documents">
          <v-col
            cols="3"
            v-for="item in districtDue.documents"
            :key="item.uuid"
          >
            <v-card v-if="item.type === 'pdf'" @click="openImage(item.path)">
              <v-chip class="ma-2" color="pink" label text-color="white">
                <v-icon left>
                  mdi-file-pdf-box
                </v-icon>
                PDF document
              </v-chip>
            </v-card>
            <v-card v-else @click="openImage(item.path)">
              <v-img
                :src="item.path"
                height="150"
                class="grey darken-4"
              ></v-img>
              <v-divider></v-divider>
              <v-card-actions class="text-h6 pa-2">
                Proof document
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import GoBackBtn from "@/components/shared/GoBackBtn";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "DistrictDueView",

  components: { GoBackBtn, Alert, Snackbars },

  data: () => ({
    month: "",
    role: localStorage.getItem("role"),
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      pending_comment: "",
    },
    boardMeeting: [],
    confirm: false,
    districtDue: [],
  }),

  mounted() {
    this.month = this.$route.params.month;
    this.getDistrictDue();
  },

  computed: {
    ...mapGetters({
      defaultExam: "defaultExam",
      defaultSubject: "defaultSubject",
    }),
  },

  methods: {
    getDistrictDue() {
      if (this.$route.params.aId !== null) {
        this.loading = true;
        ActivityService.getActivityInfo("district-dues", this.$route.params.aId)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.districtDue = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.districtDue = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
    pending() {},
    submit() {},
    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
    openImage(path) {
      window.open(path, "_blank");
    },
  },
};
</script>
